import {
  CommandBar,
  Dropdown,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { noSelectionKey } from '../../../utilities/filterAndSortingsUtil';
import { optionsMapperWithNoSelection } from '../../../utilities/mapperFunctions';
import { HeaderWithCommandBar } from './HeaderWithCommandBar';
import { getCommandBarItems } from './invitationGroupAdministrationPage/utility/getCommandBarItems';
import { InvitationGroupList } from './invitationGroupAdministrationPage/InvitationGroupList';
import { useData } from './invitationGroupAdministrationPage/utility/useData';
import { useFilterAndSort } from './invitationGroupAdministrationPage/utility/useFilterAndSort';
import { useInteractions } from './invitationGroupAdministrationPage/utility/useInteractions';
import { UpdateInvitationGroupMappingsPanel } from './invitationGroupAdministrationPage/UpdateInvitationGroupMappingsPanel';
import { InvitationGroupAdminPanelAndList } from './invitationGroupAdministrationPage/InvitationGroupAdminPanelAndList';
import {
  commandBarStyles,
  dropdownStyles,
} from './invitationGroupAdministrationPage/utility/styles';

const InvitationGroupAdministrationPage = () => {
  const { t: translator } = useTranslation();

  const {
    selectedHearingTypeKey,
    handleHearingTypeChange,
    handleInvitationGroupSelect,
    handleUpdateInvitationGroupMappings,
  } = useInteractions();

  const {
    allInvitationGroups,
    invitationGroupsByHearingTypeId,
    hearingTypes,
    isFetchingHearingTypes,
  } = useData(selectedHearingTypeKey);

  const {
    titleFilter,
    showSearchBar,
    filteredAndSortedItems,
    handleTitleFilterChange,
    toggleSearchBar,
  } = useFilterAndSort(invitationGroupsByHearingTypeId);

  const topCommandBarItems = getCommandBarItems(
    translator,
    selectedHearingTypeKey,
    handleUpdateInvitationGroupMappings,
  );

  return (
    <div className="admin-page administrationPage">
      <div className="admin-page-commandBar">
        <CommandBar items={topCommandBarItems} styles={commandBarStyles} />
      </div>
      <div className="admin-page-container">
        <HeaderWithCommandBar
          header={translator('pages.adminInvitationGroups.header')}
          titleFilterText={translator('pages.adminInvitationGroups.filterText')}
          showTitleFilter={showSearchBar}
          setShowTitleFilter={toggleSearchBar}
          titleFilter={titleFilter}
          setTitleFilter={handleTitleFilterChange}
          disableGrid={true}
        />
        {isFetchingHearingTypes ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <div>
            <Dropdown
              label={translator('hearingProperties.hearingType')}
              styles={dropdownStyles}
              options={optionsMapperWithNoSelection(translator)(hearingTypes)}
              onChange={handleHearingTypeChange}
              selectedKey={selectedHearingTypeKey}
            />
            <div className="list-spacing">
              {selectedHearingTypeKey === noSelectionKey ? null : (
                <InvitationGroupList
                  items={filteredAndSortedItems}
                  onClick={(id) => handleInvitationGroupSelect(id)}
                  onSelect={(id) => handleInvitationGroupSelect(id)}
                />
              )}
            </div>
            <InvitationGroupAdminPanelAndList />
          </div>
        )}
        <UpdateInvitationGroupMappingsPanel
          selectedHearingTypeKey={selectedHearingTypeKey}
          invitationGroupsByHearingTypeId={invitationGroupsByHearingTypeId}
          invitationGroups={allInvitationGroups}
        />
      </div>
    </div>
  );
};

export { InvitationGroupAdministrationPage };
